/**
 * Analytics — mounts Google Analytics 4 (GA4) and Meta (Facebook) Pixel
 * tags globally. IDs come from env so preview/prod can differ:
 *   REACT_APP_GA_MEASUREMENT_ID   — e.g., G-Z41C4YN1SH
 *   REACT_APP_META_PIXEL_ID       — e.g., 1234567890 (numeric)
 * Also fires SPA page-view events on route change (React Router).
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let mounted = false;

const loadScript = (src, id) => {
  if (document.getElementById(id)) return;
  const s = document.createElement('script');
  s.async = true;
  s.src = src;
  s.id = id;
  document.head.appendChild(s);
};

const mountAll = () => {
  if (mounted) return;
  mounted = true;

  // ---- GA4 ----
  if (GA_ID) {
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`, 'ga4-lib');
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA_ID, { send_page_view: true });
  }

  // ---- Meta Pixel ----
  if (META_PIXEL_ID) {
    /* eslint-disable */
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = '2.0';
      n.queue = [];
      t = b.createElement(e); t.async = !0;
      t.src = v; s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }
};

const Analytics = () => {
  const location = useLocation();

  useEffect(() => { mountAll(); }, []);

  useEffect(() => {
    // Fire SPA page_view on every route change
    if (window.gtag && GA_ID) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
      });
    }
    if (window.fbq && META_PIXEL_ID) {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname, location.search]);

  return null;
};

// Handy helpers exposed for other components to fire custom events
export const trackEvent = (name, params = {}) => {
  if (window.gtag && GA_ID) window.gtag('event', name, params);
  if (window.fbq && META_PIXEL_ID) window.fbq('trackCustom', name, params);
};

export default Analytics;
